import React from 'react';
import { cn } from '@/lib/twUtils';

export interface AttributionProps {
  name: string;
  /** Mestiere: sta di fianco al nome, in sordina — è del professionista */
  role?: string;
  /** Ragione sociale dello studio: riga tutta sua, è la prova che portiamo */
  company?: string;
  /** Su banda scura i toni si invertono */
  onDark?: boolean;
  size?: 'sm' | 'md';
  className?: string;
}

const SIZES = {
  sm: { name: 'text-[0.875rem]', role: 'text-[0.8125rem]', company: 'text-[0.8125rem]' },
  md: { name: 'text-[1rem]', role: 'text-[0.875rem]', company: 'text-[0.875rem]' },
} as const;

/**
 * Chi ha detto la frase: nome e mestiere sulla prima riga, studio sulla
 * seconda. Vive qui e non nelle singole pagine perché la citazione compare in
 * quattro posti diversi e la gerarchia dev'essere la stessa in tutti.
 */
const Attribution = ({
  name,
  role,
  company,
  onDark = false,
  size = 'sm',
  className,
}: AttributionProps) => {
  const scale = SIZES[size];

  return (
    <span className={cn('block', className)}>
      <span className={cn('block', scale.name, onDark ? 'text-white' : 'text-primary')}>
        <span className="font-semibold">{name}</span>
        {role && (
          <span className={cn(scale.role, onDark ? 'text-white/60' : 'text-ink-subtle')}>
            {/* Il punto in mezzo prende aria da margini propri: gli spazi
                normali lo lasciavano attaccato a nome e mestiere. */}
            <span className="mx-1.5">·</span>
            {role}
          </span>
        )}
      </span>
      {company && (
        <span
          className={cn(
            'mt-0.5 block font-semibold',
            scale.company,
            onDark ? 'text-white' : 'text-primary'
          )}
        >
          {company}
        </span>
      )}
    </span>
  );
};

export default Attribution;
